import { Outlet } from '@remix-run/react'
import { PageMotion } from '#app/ui/studio/page-motion.tsx'

export default function MarketingLayout() {
	return (
		<div className="studio-dusk min-h-full bg-ink text-linen">
			<PageMotion>
				<Outlet />
			</PageMotion>
		</div>
	)
}
